import { gql } from '@apollo/client'

const CREATE_OR_RETRIEVE_CLOUDINARY_CONFIG = gql`
  mutation createOrRetrieveCloudinaryConfig($orgId: Int!) {
    createOrRetrieveCloudinaryConfig(orgId: $orgId) {
      cloudinaryId
    }
  }
`

export default CREATE_OR_RETRIEVE_CLOUDINARY_CONFIG
